import React from 'react'
import { motion } from 'framer-motion'

const item = (delay) => ({
  initial:    { opacity: 0, y: 18 },
  animate:    { opacity: 1, y: 0 },
  transition: { duration: 0.8, delay, ease: [0.22, 1, 0.36, 1] },
})

export default function Hero({ thumb }) {
  return (
    <div className="cp-hero">
      {thumb && (
        <div className="cp-hero__bg">
          <img src={thumb} alt="Contact" />
        </div>
      )}
      <div className="cp-hero__overlay" />
      <div className="cp-hero__content">
        <motion.span className="cp-hero__eyebrow" {...item(0.1)}>
          Le Journey Cruises
        </motion.span>
        <motion.h1 className="cp-hero__title" {...item(0.25)}>
          Get in Touch
        </motion.h1>
      </div>
    </div>
  )
}
